import Application from '../common/models/Application';
import ApplicationKey from '../common/models/ApplicationKey';
import ApplicationConfig from '../common/models/ApplicationConfig';

export default {
    'xtreh/phoenix/models/Application': Application,
    'xtreh/phoenix/models/ApplicationKey': ApplicationKey,
    'xtreh/phoenix/models/ApplicationConfig': ApplicationConfig,
};
